import { parseCookie, stringifySetCookie } from 'cookie';

export function getCookieFromDocument(name: string): string | undefined {
  const cookies = parseCookie(document.cookie);
  return cookies[name];
}

export function getRootDomain(location?: {
  hostname: string;
}): string | undefined {
  const hostname =
    location?.hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : undefined);
  if (!hostname) return undefined;
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  ) {
    return undefined;
  }
  const parts = hostname.split('.');
  return parts.length >= 2 ? '.' + parts.slice(-2).join('.') : undefined;
}

/**
 * Sets a cookie on the root domain so it is shared across subdomains.
 * Falls back to no explicit domain on localhost or IP addresses.
 */
export function setCookieForRootDomain(
  name: string,
  value: string,
  maxAge?: number
): void {
  const rootDomain = getRootDomain();
  const domainPart = rootDomain ? `; domain=${rootDomain}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
}

export function setCookie(
  name: string,
  value: string,
  /**
   * Expiry, in seconds. An undefined value results in a session cookie.
   * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Cookies#removal_defining_the_lifetime_of_a_cookie
   */
  maxAge?: number
): void {
  if (typeof document === 'undefined') return;
  const cookieString = stringifySetCookie(name, value, {
    maxAge,
    path: '/',
    sameSite: 'lax',
  });
  document.cookie = cookieString;
}
